export default __webpack_public_path__ + "static/media/appletv.1963ee9d.png";